import axios from "axios";
import { applyFormulaAll } from '../Templates/actions'
import { EMULATION_ALL, buildRequestUrl, execWithApiToken, EmulatedProductData } from '../../GlobalStateContainer/actions'


const EMULATION_MODE_PRODUCTVIEW = false


/*
 * Product View Actions
 * 
 */

export function fetchProduct(id) {
    let cmd = 'FETCH_PRODUCT'

    if (EMULATION_ALL || EMULATION_MODE_PRODUCTVIEW)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: { 
                    data: EmulatedProductData[0]
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('Product/') + id, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )

                    applyFormulaAll.bind(this)(
                        {
                            productTemplateId: resp.data.productTemplateId,
                            productMasterId: resp.data.productMasterId
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchProductError(dispatch) {

    dispatch(
        {
            type: 'FETCH_PRODUCT_ERROR'
        }
    )
}


export function fetchProductOverrides(id) {
    let cmd = 'FETCH_PRODUCT_OVERRIDES'

    if (EMULATION_ALL || EMULATION_MODE_PRODUCTVIEW)
        //TODO
        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData[id - 1]
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('productoverridetemplate/') + id, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function saveProductOverrides(id, overrides) {
    let cmd = 'SAVE_PRODUCT_OVERRIDES'

    if (EMULATION_ALL || EMULATION_MODE_PRODUCTVIEW)
        //TODO
        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData[id - 1]
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('productoverridetemplate/') + id, JSON.stringify(overrides), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorProductOverrides(dispatch) {

    dispatch(
        {
            type: 'PRODUCT_OVERRIDES_ERROR'
        }
    )
}


